module.exports = __webpack_public_path__ + "img/tanhao.e4ca78bf.svg";